<template>
  <div class="golf-protection-form-wrap">
    <golf-protection-form :showSkipButton="false"></golf-protection-form>
  </div>
</template>
<script>
export default {
  name: 'ProtectionForm'
}
</script>
